export default function() {
    (function ($) {

        $(document).ready(function() {

            const easeOutQuart = (t, b, c, d) => {
                return -c * ((t = t / d - 1) * t * t * t - 1) + b;
            };
            function commaSeparateNumber(val){
                while (/(\d+)(\d{3})/.test(val.toString())){
                    val = val.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
                }
                return val;
            }
            const animate = (value, el, comma) => {
                const time = {
                    total: 1500, //Haw long the animation is im ms
                    start: performance.now()
                };
                const tick = now => {
                    const elapsed = now - time.start,
                        progress = easeOutQuart(elapsed, 0, 1, time.total);

                    $(el).css({'width': $(el).outerWidth()}); // Set width to current width, so text after dont jump
                    if (!comma) {
                        $(el).text(Math.round(progress * parseInt(value)).toLocaleString());
                    } else {
                        $(el).text(commaSeparateNumber(Math.round(progress * parseInt(value))));
                    }
                    elapsed >= time.total ? $(el).css({'width': ''}) : null; // Remove width when animation ends
                    elapsed < time.total ? window.requestAnimationFrame(tick) : null;
                }
                window.requestAnimationFrame(tick);
            }

            window.addEventListener('load', () => {
                $(".counter_headline").each(function () {
                    var $this = $(this);
                    var $numberWithComma = false;
                    if ($this.text().indexOf(',') > -1) {
                        $numberWithComma = !$numberWithComma;
                    }
                    var $number = $this.text().replace(/[^0-9]/gi, ''); // Remove everything what is not a number
                    $($this).css({'width': $($this).outerWidth()});
                    $this.text(0); //Set number to 0

                    setTimeout(function () {
                        gsap.to($this, {
                            ease: Power3.easeOut,
                            scrollTrigger: {
                                trigger: $this,
                                start: "top 70%",
                            },
                            onStart: function() {
                                animate($number, $this, $numberWithComma); // Start animation on scroll
                            }
                        })

                    }, 0); // How long to wait for loading animation

                });
            });

        });


    })(jQuery);
}